import * as React from 'react';

import OutfitMediaToPublish from 'modules/realm-outfits/components/outfit-media-to-publish/OutfitMediaToPublish';
import DeliverableSubHeader from '../../deliverable-sub-header/DeliverableSubHeader';

import { __t, applyTranslations } from 'utils/language';
import { getOutfitsWithoutDraft } from 'utils/realm-outfits';

import './deliverable-outfit-content-for-review.scss';

applyTranslations(require('./deliverable-outfit-content-for-review.i18n.json'));

import { Campaign, RealmOutfit, SubcampaignInfluencerProfile } from 'types';

type Props = {
  campaign: Campaign,
  outfits: Array<RealmOutfit>,
  deliverableId: number,
  offerId: number,
  creatorWmcLink: string | null,
  isForBrand?: boolean,
  influencerProfile?: SubcampaignInfluencerProfile,
  onSelectMoveOutfitToAnotherDeliverable?: (outfit: RealmOutfit, checked: boolean) => void
};

const msgKey = 'deliverable_outfit_content_for_review';

const DeliverableOutfitContentForReview = ({
  campaign,
  isForBrand,
  outfits,
  influencerProfile,
  deliverableId,
  offerId,
  creatorWmcLink,
  onSelectMoveOutfitToAnotherDeliverable
}: Props) => {
  const filteredOutfits = isForBrand ? getOutfitsWithoutDraft(outfits || []) : outfits;
  const isEmptyMode = filteredOutfits.length === 0;

  const instruction = __t(`${msgKey}.instruction.${isForBrand ? 'brand' : 'influencer'}`);

  return (
    <React.Fragment>
      <DeliverableSubHeader
        title={__t(`${msgKey}.labels.outfits`)}
        instruction={isEmptyMode ? '' : instruction}
        directon={isEmptyMode ? 'row' : 'column'}
        emptyNote={isEmptyMode ? __t(`${msgKey}.content_empty_note`) : ''}
      />
      <div className="deliverable-outfit-content-for-review__outfits">
        {
          filteredOutfits.map((outfit, index) => (
            <OutfitMediaToPublish
              campaign={campaign}
              key={outfit.id}
              deliverableId={deliverableId}
              creatorWmcLink={creatorWmcLink}
              offerId={offerId}
              isForBrand={isForBrand}
              influencerProfile={influencerProfile}
              outfit={outfit}
              onSelectMoveOutfitToAnotherDeliverable={onSelectMoveOutfitToAnotherDeliverable}
              outfitPosition={index}
            />
          ))
        }
      </div>
    </React.Fragment>
  );
};

export default DeliverableOutfitContentForReview;
